module.exports = __webpack_public_path__ + "img/404@2x.821b9707.png";